import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import { Messages } from '../../../gen-src/Localize';
import {
  VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery,
  VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery_virtualConnectionTables_columnsConnection_nodes_downstreamDashboardsConnection_nodes,
  VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery';
import {
  VirtualConnectionTableDownstreamDashboardsQuery,
  VirtualConnectionTableDownstreamDashboardsQuery_virtualConnectionTables_downstreamDashboardsConnection_nodes,
  VirtualConnectionTableDownstreamDashboardsQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTableDownstreamDashboardsQuery';
import { DashboardSortOrder } from '../../../gen-src/queries/globalTypes';

import { VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryGql } from '../../queries/VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryGql';
import { VirtualConnectionTableDownstreamDashboardsQueryGql } from '../../queries/VirtualConnectionTableDownstreamDashboardsQueryGql';
import { getRowDataForDashboard, DashboardsDisplayGrid, DashboardsDisplayGridRowData } from '../sharedDisplayGrid/DashboardsDisplayGrid';
import { DashboardsValidSortFields } from '../sorting/sortProviders/DashboardsGridSortProvider';


type QueryVariables = VirtualConnectionTableDownstreamDashboardsQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamDashboardsQuery;
type QueryResultListNode = VirtualConnectionTableDownstreamDashboardsQuery_virtualConnectionTables_downstreamDashboardsConnection_nodes;
type GridRowData = DashboardsDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery;
type QueryResultListNodeWithFilter =
  VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery_virtualConnectionTables_columnsConnection_nodes_downstreamDashboardsConnection_nodes;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
    resultData.virtualConnectionTables[0].downstreamDashboardsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamDashboardsConnection : null;
}

export type VirtualConnectionTableDownstreamDashboardsQueryGridProps = GridSortProps<DashboardsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
};

export function VirtualConnectionTableDownstreamDashboardsQueryGrid(props: VirtualConnectionTableDownstreamDashboardsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDashboardsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDashboardsLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Dashboard as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as DashboardSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForDashboard}
    >
      {({ rowStore }) =>
        <DashboardsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamDashboardsQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as DashboardSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDashboard}
    >
      {({ rowStore }) =>
        <DashboardsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
    </PaginatedQueryWrapper>
  );
}
